import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./MartOwnerLogin.css";

const MartOwnerLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      // Calling the backend controller we created
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/owner/mart-owner/login`, {
        email,
        password,
      });

      if (response.data.success) {
        // Store owner data in localStorage to keep them logged in
        localStorage.setItem("martOwner", JSON.stringify(response.data.owner));
        navigate("/owner-portal");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="owner-login-container">
      <div className="login-card">
        <div className="login-header">
          <button className="back-link" onClick={() => navigate("/mars-mart/home")}>← Back</button>
          <h2>Owner Login</h2>
          <p>Manage your MarsMart branch</p>
        </div>

        <form onSubmit={handleLogin} className="login-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="input-group">
            <label>Email Address</label>
            <input
              type="email"
              placeholder="marsmate@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label>Password</label>
            <input
              type="password"
              placeholder="marsmate123"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? "Verifying..." : "LOGIN TO PORTAL"}
          </button>
        </form>

        <div className="login-footer">
          <p>Forgot password? Contact MarsMart Support</p>
        </div>
      </div>
    </div>
  );
};

export default MartOwnerLogin;